






































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseVue from "@/core/BaseVue";
import Province from "@/models/province.model";
import Municipality from "@/models/municipality.model";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";

@Component({
  components: {  }
})
export default class RegionProvinciaMunicipioComponent extends BaseVue {
  @Prop() public value!: Province;
  @Prop() public direccionId!: number;

  model = {
    provinceId:undefined,
municipalityId:undefined
  };
  location: any = String();
  provincia: any = {};
  municipio: any = {};

  selectProvincia(value: any, added: boolean = true) {
    if (added) {
      this.provincia = value;
    } else {
      this.model.provinceId = undefined;
      this.provincia = {};
    }

    this.$emit("provincia", value);
  }
}
